function closeBox(key, id, formKey) {
  const boxKey = formKey ? `${formKey}-box` : 'box';
  const dynamic = formKey ? `${formKey}-dynamic` : 'box';
  $('#' + boxKey + '-' + key + '-' + id).remove();
  const dynamicEl = $('#' + dynamic + '-' + key);
  dynamicEl.find('.condition-value:first')
    .find('.and-or:first')
    .remove();
  dynamicEl.find('.condition-value:first')
    .find('i')
    .css('margin-top', 0);
}

function addInput(key, id, label, type, formKey) {
  const boxKey = formKey ? `${formKey}-box` : 'box';
  const group = formKey ? `${formKey}-group` : 'group';
  const value = formKey ? `${formKey}-value` : 'value';

  let html = '';
  const boxKeyEl = $('#' + boxKey + '-' + key + '-' + id);
  if (type === 'text') {
    boxKeyEl.find('.input-text').remove();
    html = `<input type="text" class="form-control input-text" style="height: 25px; margin-left: 10px;width: 150px;"
                   id="${value}-` + key + `-` + id + `-` + label + `"
                   data-key="` + key + `"
                   data-index="` + id + `"
                   data-label="` + label + `">`;
  } else if (type === 'select') {
    boxKeyEl.find('.select2').remove();
    boxKeyEl.find('.group-select').remove();
    html = `<div class="group-select">
                <select type="text" class="form-control input-select" style="height: 25px; margin-left: 10px;width: 150px;"
                        id="${value}-` + key + `-` + id + `-` + label + `"
                        data-key="` + key + `"
                        data-index="` + id + `"
                        data-label="` + label + `" >`;
    html += '<option value=""></option>';
    const data = $('#' + boxKey + '-' + key).data('x');
    data.forEach((e) => {
      html += '<option value="' + e.id + '">' + e.text + '</option>';
    });
    html += '</select></div>';
  } else if (type === 'date') {
    boxKeyEl.find('.input-date').remove();
    boxKeyEl.find('.group-date').remove();
    html =
      `<div class="input-group group-date">
          <input type="text" data-plugin="datepicker" class="form-control input-date" style="height: 25px; margin-left: 10px;width: 150px;"
                id="${value}-` + key + `-` + id + `-` + label + `"
                data-key="` + key + `"
                data-index="` + id + `"
                data-label="` + label + `">`;
    html += `<span class="input-group-addon" style="height:25px">
               <i class="icon wb-calendar" aria-hidden="true"></i>
             </span>
       </div>`;
  } else if (type === 'number') {
    boxKeyEl.find('.input-number').remove();
    html = `<input type="number" class="form-control input-number" style="height: 25px; margin-left: 10px;width: 150px;"
                   id="${value}-` + key + `-` + id + `-` + label + `"
                   data-key="` + key + `"
                   data-index="` + id + `"
                   data-label="` + label + `">`;
  }

  $('#' + group + '-input-' + key + '-' + id + '-' + label).append(html);
  if (type === 'select') {
    $('.input-select').select2({
      placeholder: '--chọn--',
      containerCss: {
        'font-size': '12px',
        height: '25px',
        'margin-top': '-2px',
      },
    });
  }
  if (type === 'date') {
    $('.input-date').datepicker({ format: 'dd-mm-yyyy' });
  }
}



// WEBPACK FOOTER //
// src/assets/evs/js/main.js